"use strict";

blocks.register('saved-searches', function () {
    var savedId;
    var showSearchName = false;
    var $savedSearchHiddenInput;
    var $input;
    var $delete;
    var searchKey;

    var block;
    var wrapper;

    function toggleSavedSearchPageing() {
        var pagingLinks = $(".search-page .pagination .arrow:not(.unavailable) a");
        var sortingHeaders = $(".search-page .search-result-table__head .sorting-header");

        pagingLinks.add(sortingHeaders).each(modyfyLink);
    }

    function modyfyLink() {
        var linkUrl = $(this).attr("href");
        var linkParts = linkUrl.split('?');

        var parameterIndex = linkParts[1].indexOf("SavedSearchId");
        var savedParam = ("SavedSearchId=" + savedId + "&").replace(' ', '+');

        if (showSearchName) {
            if (parameterIndex === -1) {
                linkParts[1] = savedParam + linkParts[1];
            }
        } else {
            if (parameterIndex !== -1) {
                //before savedParam index
                linkParts[1] = linkParts[1].substring(0, parameterIndex) +
                //after index+savedParam.length
                linkParts[1].substring(parameterIndex + savedParam.length, linkParts[1].length);
            }
        }
        $(this).attr("href", linkParts.join('?'));
    }

    function resetSearch() {
        showSearchName = false;
        $savedSearchHiddenInput.val('');
        $input.select2('val', '');
        toggleSavedSearchPageing();
        savedId = null;
    }

    function changeDropdown(response) {
        if (!response.IsSuccess) return;
        $savedSearchHiddenInput.val(response.id);
        savedId = response.id;
        var $html = $(response.html);
        wrapper.replaceWith($html);
        blocks.compile($html);
    }

    function initDeldeteButton() {
        $delete = $('.saved-searches__delete');

        $delete.removeClass('dn');
        $delete.off('click').on('click', deleteButtonClick);
    }

    function deleteButtonClick() {
        var url = ["/SavedSearches/Delete?id=", savedId, '&searchKey=', searchKey].join('');
        popup.showConfirmModal('Are you sure you want to delete saved search?', function () {
            $.ajax({
                url: url,
                type: "DELETE"
            }).done(changeDropdown);
        });
    }

    return {
        link: function link($block) {
            block = $block;
            wrapper = $block.closest('.saved-searches__wrapper');
            $input = $block.find('.saved-searches__select');

            var $advancedFormInputs = $('.advanced-tools-search-form input').not($savedSearchHiddenInput);
            var $clearSearchButton = $('.clear-form-button'),
                $saveAsPersonalDefaultSearchButton = $('a.save-as-personal-default-search-button'),
                $saveAsSystemDefaultSearchButton = $('a.save-as-system-default-search-button');

            var searchesById = {};

            $savedSearchHiddenInput = $('#SavedSearchId');
            $input.select2({
                placeholder: "Saved Searches",
                formatNoMatches: function formatNoMatches(term) {
                    return "No Saved Searches";
                },
                formatResult: function formatResult(data) {
                    var $element = $(data.element),
                        elementData = $element.data();
                    if (!data.id || !$element.is('option') || !elementData.isPersonalDefault && !elementData.isSystemDefault) {
                        return data.text;
                    }
                    return getDefaultSearchResult(data.text, elementData);
                }
            });

            function getDefaultSearchResult(text, elementData) {
                var result = ['<span class="saved-searche-default" title="Default search">', '<span>' + text + '</span>', elementData.isPersonalDefault ? '<small>Personal default</small>' : '', elementData.isSystemDefault ? '<small class="system-default">System default</small>' : '', '</span>'].join('');

                return result;
            }

            $input.removeClass('dn');
            savedId = $savedSearchHiddenInput.val();

            $input.find('option').each(function (index, element) {
                var $element = $(element),
                    id = $element.attr('data-id'),
                    userCanDelete = $element.attr('data-deleteble');

                if (id) {
                    searchesById[id] = {
                        name: $element.text().trim(),
                        id: id,
                        value: JSON.parse($element.attr('data-configuration')),
                        userCanDelete: userCanDelete,
                        isPersonalDefault: $element.data('isPersonalDefault'),
                        isSystemDefault: $element.data('isSystemDefault')
                    };
                }
            });

            var selectedOption = searchesById[savedId];

            if (savedId) {
                showSearchName = true;
                toggleSavedSearchPageing();
            }
            //set record according to parametr
            $input.select2('val', selectedOption && savedId);

            if (selectedOption && selectedOption.userCanDelete === 'true') {
                initDeldeteButton();
            }

            //reset on any change
            $advancedFormInputs.on('change', resetSearch);

            $clearSearchButton.on('click', resetSearch);

            initAdvancedTools();

            $input.on("change", function (e) {
                var id = e.val;
                if (id) {
                    var searchConfiguration = [].concat(searchesById[id].value, { "name": "SavedSearchId", "value": e.val });
                    var $searchForm = $(".search-page .search-advanced-tools form.search-form");
                    clearSearchForm($searchForm);
                    $searchForm.deserialize(searchConfiguration).submit();
                }
            });
        }
    };

    function initAdvancedTools() {
        searchKey = $('.save-search-button').attr("data-search-key");

        $('.save-search-button').off('click').on('click', function () {
            showSaveSearchForm({ command: $(this) });
        });

        $('.save-search-predifined-button').off('click').on('click', function () {
            showSaveSearchForm({ isAdmin: true, command: $(this) });
        });

        $('.save-as-personal-default-search-button').off('click').on('click', function () {
            saveAsDefaultSearchForm(false, $(this));
        });

        $('.save-as-system-default-search-button').off('click').on('click', function () {
            saveAsDefaultSearchForm(true, $(this));
        });
    }

    function saveAsDefaultSearchForm(isSystemDefault, command) {
        if (savedId) {
            $.ajax({
                url: '/SavedSearches/MakeDefault?id={0}&searchKey={1}&isSystemDefault={2}'.$format(savedId, searchKey, isSystemDefault),
                type: 'POST'
            }).done(changeDropdown);
        } else {
            showSaveSearchForm({
                command: command,
                isSystemDefault: isSystemDefault
            });
        }
    }

    function showSaveSearchForm(options) {

        var $inputs = $("<div class='form-group'>" + "<label class='control-label'>Search Name<span class='required'>*</span></label>" + "<input type='text' name='search-name' class='form-control' data-val='true' data-val-required='Search Name is required.' />" + "<span class='field-validation-valid' data-valmsg-for='search-name' data-valmsg-replace='true'></span>" + "</div>");

        var $command = options.command;
        var $form = $command.closest("form");

        showModalDynamicForm($inputs, {
            submitButtonLabel: 'Save',
            submitHandler: function submitHandler(formModel) {
                var searchName = formModel["search-name"];
                var searchConfiguration = $form.serializeArray();
                var searchConfigurationString = JSON.stringify(searchConfiguration);
                $.ajax({
                    url: "/SavedSearches/New",
                    type: "POST",
                    data: {
                        searchKey: searchKey,
                        searchName: searchName,
                        searchConfiguration: searchConfigurationString,
                        isAdmin: !!(options && options.isAdmin),
                        isSystemDefault: options.isSystemDefault
                    }
                }).done(changeDropdown);
            }
        });
    }
});